// Dependencies
import { FC } from "react";

// Components
import WalletType from "./WalletType";

// Types
import { WALLET_TYPE } from "~/enums";

// Styles
import { StyledAction, StyledLabel } from "./WalletChooseType.styled";
import { StyledCard } from "~/components/Common";

interface WalletChooseTypeProps {
  onChoose: Function;
}

const WalletChooseType: FC<WalletChooseTypeProps> = ({ onChoose }) => {
  return (
    <StyledCard>
      <StyledLabel>Choose a wallet type that you want to add</StyledLabel>
      <StyledAction>
        {Object.entries(WALLET_TYPE).map(([type, data]) => (
          <WalletType
            onClick={() => onChoose(type)}
            label={type}
            color={data.tagColor}
          />
        ))}
      </StyledAction>
    </StyledCard>
  );
};

export default WalletChooseType;
